import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AITranslationPage from './pages/AITranslationPage';
import TranslationPage from './pages/TranslationPage';
import UserGuide from './pages/UserGuide';
import NewsletterReview from './pages/NewsletterReview';
import NewsletterCompare from './pages/NewsletterCompare';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// Configure User Pool authentication only. The generated aws-exports.js also
// includes an Identity Pool that is currently rejecting credentials.
// Keep the generated file unchanged; this app uses User Pool JWTs for API roles.
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: awsExports.aws_user_pools_id,
            userPoolClientId: awsExports.aws_user_pools_web_client_id,
        },
    },
});

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/translation" element={<TranslationPage />} />
                <Route path="/ai-translation" element={<AITranslationPage />} />
                <Route path="/userguide" element={<UserGuide />} />
                <Route path="/newsletter-review" element={<NewsletterReview />} />
                <Route path="/newsletter-compare" element={<NewsletterCompare />} />
            </Routes>
        </Router>
    );
}

export default App;
